const rcsMaxLength = 9;

export const registrationNumber = {
  rcsMaxLength
};
